/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import {
   Button, Card, CardBody, Col, Input, Row, Table,
   Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import NumberFormat from "react-number-format";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import _ from "lodash";
import { BOMTypeahead, ConfirmModal, ItemDropdownMenu, Pager, ServiceThreadSpinner, } from ".";
import { DesktopContainer } from "../layouts";
import { api, dateHelpers, helpers, constants, reportHelpers, UserContext } from "../utils";

export default function BOMComponents(props) {
   const location = useLocation();
   const navigate = useNavigate();
   const { bomComponent } = useParams();
   const { currentUser } = useContext(UserContext);
   const [selectedItem, setSelectedItem] = useState(location.state);

   const [bom, setBom] = useState({});
   const [bomTotalCosts, setBomTotalCosts] = useState({
      laborOverhead: 0,
      component: 0,
   });
   const [calculatingPkgQty, setCalculatingPkgQty] = useState(false);
   const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
   const [confirmDelete, setConfirmDelete] = useState(null);
   const [confirmComponentDelete, setConfirmComponentDelete] = useState(null);
   const [editBomCopy, setEditBomCopy] = useState(null);
   const editing = editBomCopy !== null;
   const [editTariffCopy, setEditTariffCopy] = useState(null);
   const [handleConfirmConfirmationModal, setHandleConfirmConfirmationModal] = useState(() => { });
   const isSampleBom = selectedItem && _.startsWith(_.toUpper(selectedItem.value), "SP");
   const [itemClass, setItemClass] = useState({});
   const [newComponent, setNewComponent] = useState({
      itemGroup: constants.BOM_GROUP.Yarn,
      item: null,
      quantity: 1,
      siteId: null,
   });
   const [newComponentPkgQty, setNewComponentPkgQty] = useState("");
   const [refData, setRefData] = useState({});
   const [screenOptions, setScreenOptions] = useState({
      canEdit: false,
      showRevision: false,
   });
   const [showNoBomMessage, setShowNoBomMessage] = useState(false);
   const [tariffInfo, setTariffInfo] = useState({});
   const [whereUsedItem, setWhereUsedItem] = useState(null);
   const [whereUsedItemList, setWhereUsedItemList] = useState([]);
   const [working, setWorking] = useState(false);
   const [wuPage, setWuPage] = useState({ number: 1, size: 10 });
   const [wuTotal, setWuTotal] = useState(0);
   const [wuWorking, setWuWorking] = useState(false);
   const componentsIncomplete =
      bom && bom.componentCollection && bom.componentCollection.length > 0 &&
      _.some(
         bom.componentCollection,
         (cmp) =>
            _.isNil(cmp.siteId) ||
            _.trim(cmp.siteId).length === 0 ||
            cmp.unitsPerSku <= 0 ||
            cmp.quantity <= 0 ||
            cmp.wastePercent < 0
      );
   const headerIncomplete =
      _.isNil(bom) ||
      _.isNil(bom.standardNetWeight) ||
      _.trim(bom.standardNetWeight).length === 0 ||
      _.isNil(bom.unitsPerSku) ||
      _.trim(bom.unitsPerSku).length === 0 ||
      (itemClass.isFinishedGood &&
         (_.isNil(bom.tareWeight) || _.trim(bom.tareWeight).length === 0));


   useEffect(() => {
      if (location.search) {
         const queryParams = new URLSearchParams(location.search);
         const bom = queryParams.get("bomComponent");
         setSelectedItem(JSON.parse(bom));
      } else if (bomComponent) {
         const json = decodeURI(bomComponent);
         const opt = JSON.parse(json);
         setSelectedItem(opt);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   useEffect(() => {
      document.title = `BoM Card`;
      if (!currentUser) return;
      if (currentUser.isAdmin || currentUser.isPowerUser || currentUser.isEngineerEdit || currentUser.isInventoryEdit) {
         setScreenOptions({ ...screenOptions, canEdit: true });
      }
      const componentTypes = _.map(constants.BOM_GROUP, (value, key) => ({
         label: key,
         value: value,
      }));
      api
         .fetch("BOM/LoadBOMCardRefData")
         .then((r) =>
            setRefData(
               _.assign({
                  componentTypes: _.slice(componentTypes, 1),
                  packageTypes: [
                     { label: "Cone/Tube/Spool", value: 1 },
                     { label: "Box/Divider", value: 2 },
                  ],
               },
                  r.data
               )
            )
         )
         .catch(api.catchHandler);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentUser]);

   useEffect(() => {
      if (location.state !== selectedItem) {
         setSelectedItem(location.state);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [location]);

   useEffect(() => {
      refreshData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [selectedItem]);

   useEffect(getWhereUsed, [whereUsedItem, wuPage]);

   useEffect(() => {
      if (!whereUsedItem) return;
      const section = document.querySelector("#whereUsedTable");
      section.scrollIntoView({ behavior: "smooth", block: "start" });
   }, [whereUsedItem]);

   function downloadBomPdf() {
      setWorking(true);
      api
         .postDownloadBinary(
            `Report/BillOfMaterials`,
            { ItemNumber: selectedItem.value },
            constants.MIME_TYPES.pdf,
            `Bill_of_Materials_${selectedItem.value}_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
            "There was an error downloading the Bill of Materials pdf."
         )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setWorking(false));
   }

   function downloadComponentXLSX() {
      api
         .postGetBlob("BOM/DownloadComponentsXLSX", { ItemNumber: selectedItem.value })
         .then((response) => {
            if (response && response.data) {
               const XLSX_FILENAME = `${selectedItem.value}_BOM_Components.xlsx`;
               helpers.downloadExport(
                  response.data,
                  XLSX_FILENAME,
                  constants.MIME_TYPES.xlsx
               );
            } else {
               toast.error(response.message || "Error downloading report");
            }
         })
         .catch(api.catchHandler);
   }

   function getBomComponentValue(key, index, defaultValue = "") {
      const value = editBomCopy === null
         ? bom.componentCollection[index][key]
         : editBomCopy.componentCollection[index][key];
      return _.isNil(value) ? defaultValue : value;
   }

   function getBomHeaderValue(key, defaultValue = "") {
      const value = editBomCopy === null ? bom[key] : editBomCopy[key];
      return _.isNil(value) ? defaultValue : value;
   }

   function getTareCheckValue(key, index, defaultValue = "") {
      const value = editBomCopy === null
         ? bom.pkgCollection[index][key]
         : editBomCopy.pkgCollection[index][key];
      return _.isNil(value) ? defaultValue : value;
   }

   function getTariffValue(key, defaultValue = "") {
      const value = editTariffCopy === null ? tariffInfo[key] : editTariffCopy[key];
      return _.isNil(value) ? defaultValue : value;
   }

   function getWhereUsed() {
      setWuWorking(true);
      api
         .post("Inventory/GetPaginatedWhereUsed", {
            itemNumber: whereUsedItem,
            showDiscontinued: false,
            pageNumber: wuPage.number,
            pageSize: wuPage.size,
         })
         .then((response) => {
            if (response.data.success) {
               setWhereUsedItemList(response.data.whereUsed.items);
               setWuTotal(response.data.whereUsed.totalCount);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setWuWorking(false));
   }

   function handleBomComponentCreate() {
      setWorking(true);
      const payload = _.assign(newComponent, {
         itemNumber: newComponent.item.itemNumber,
         bomId: bom.bomId,
      });
      if (newComponent.itemPkgType)
         payload.pkgType = newComponent.itemPkgType;

      if (newComponent.itemTareWeight)
         payload.tareWeight = payload.itemTareWeight;

      if (newComponent.item.itemNumber.startsWith("SP") && !bom.itemNumber.startsWith("SP")) {
         toast.error("Only sample items can contain other sample items as a component.");
         setWorking(false);
         return;
      }

      if (_.includes(bom.componentCollection, newComponent.item.itemNumber)) {
         toast.error("This component is already part of the BOM and cannot be added again.");
         setWorking(false);
         return;
      }

      if (newComponent.itemGroup === constants.BOM_GROUP.Yarn && bom.pkgWeightNom <= 0) {
         toast.error("Parent item has no nominal package weight. Component item cannot be added.");
         setWorking(false);
         return;
      }

      if (newComponent.itemGroup === constants.BOM_GROUP.Chemical &&
         bom.itemClass !== "BOND MIX" &&
         !bom.componentCollection.find((c) => c.itemGroup === 3)
      ) {
         toast.error("A Yarn item must be present before adding a Chemical item");
         setWorking(false);
         return;
      }

      api
         .post(`BOM/SaveBomComponent/${selectedItem.value}`, payload)
         .then((r) => {
            if (r.data.success) {
               if (r.data.message) toast.warning(r.data.message);
               else toast.success("Component added!");
               refreshData();
               setNewComponent({
                  itemGroup: constants.BOM_GROUP.Yarn,
                  item: null,
                  quantity: 1,
                  siteId: null,
               });
            } else {
               toast.error(r.data.message);
               setWorking(false);
            }
         })
         .catch((err) => {
            api.catchHandler(err);
            setWorking(false);
         });
   }

   function handleBomComponentDelete() {
      setWorking(false);
      api
         .delete(`BOM/DeleteBomComponent/${confirmComponentDelete}`)
         .then((r) => {
            if (r.data.success) {
               toast.success("Component Deleted!");
               setConfirmComponentDelete(null);
               refreshData();
            } else {
               toast.error(r.data.message);
               setWorking(false);
            }
         })
         .catch((err) => {
            api.catchHandler(err);
            setWorking(false);
         });
   }

   function handleBomHeaderDelete() {
      setWorking(true);
      api
         .delete(`BOM/DeleteBom/${bom.bomId}`)
         .then((r) => {
            if (r.data.success) {
               toast.success("BOM Deleted!");
               setConfirmDelete(false);
               refreshData();
            } else {
               toast.error(r.data.message);
               setWorking(false);
            }
         })
         .catch((err) => {
            api.catchHandler(err);
            setWorking(false);
         });
   }

   function handleBomHeaderEdit(key, value) {
      if (_.isNil(editBomCopy)) return;
      const bomCopy = _.assign({}, editBomCopy);
      bomCopy[key] = value;
      setEditBomCopy(bomCopy);
   }

   function handleBomHeaderSave(bomItm) {
      setWorking(true);
      api
         .post("BOM/SaveBom", bomItm)
         .then((r) => {
            if (r.data.success) {
               if (r.data.message) toast.warning(r.data.message);
               refreshData();
            } else {
               toast.error(r.data.message);
               setWorking(false);
            }
         })
         .catch((err) => {
            api.catchHandler(err);
            setWorking(false);
         });
   }

   function handleBomUnitEdit() {
      if (_.isNil(editBomCopy)) return;
      const bomCopy = _.assign({}, editBomCopy);
      const oldUnits = parseFloat(bom.unitsPerSku || 0);
      const isEachType = itemClass.isEach; // constants.Is_Each.includes(bomCopy.itemClass);

      //console.log(bomCopy.componentCollection);
      _.forEach(bomCopy.componentCollection, (comp) => {
         switch (comp.itemGroup) {
            case constants.BOM_GROUP.Yarn:
               if (isEachType) {
                  comp.unitsPerSku = bomCopy.unitsPerSku * comp.quantity;
               } else {
                  if (comp.unitsPerSku <= 0) {
                     comp.unitsPerSku = bomCopy.standardNetWeight * comp.quantity;
                  }
               }
               break;

            case constants.BOM_GROUP.Packaging:
               if (comp.unitsPerSku <= 0) {
                  if (isEachType) {
                     comp.unitsPerSku = comp.quantity * bomCopy.unitsPerSku;
                  } else {
                     comp.unitsPerSku = comp.quantity * bomCopy.standardNetWeight;
                  }
               } else if (comp.unitsPerSku === oldUnits) {
                  comp.unitsPerSku = bomCopy.unitsPerSku;
                  if (isEachType) {
                     comp.quantity = 1;
                  } else {
                     comp.quantity = bomCopy.unitsPerSku / parseFloat(bomCopy.standardNetWeight);
                  }
                  comp.extendedCost = comp.currentCost * (comp.quantity + comp.wastePercent);
               }
               break;

            case constants.BOM_GROUP.Chemical:
               if (isEachType) {
                  comp.unitsPerSku = bomCopy.unitsPerSku * comp.quantity;
               } else {
                  if (comp.unitsPerSku <= 0) {
                     comp.unitsPerSku = bomCopy.standardNetWeight * comp.quantity;
                  }
               }
               break;

            default:
               toast(`Unable to determine the component type of ${comp.itemNumber}!`);
               return;
         }
         updateCost(bomCopy);
         setEditBomCopy(bomCopy);
      });
      handleBomHeaderSave(bomCopy);
   }

   function handleMinOrderQtyEdit() {
      if (_.isNil(editBomCopy)) return;

      let oldUnits = parseInt(bom.unitsPerSku, 10) || 0;
      let newUnits = parseInt(editBomCopy.unitsPerSku, 10) || 0;
      let oldWgt = parseInt(bom.standardNetWeight, 10) || 0;
      let newWgt = parseInt(editBomCopy.standardNetWeight, 10) || 0;
      if (oldUnits !== newUnits)
         handleBomUnitEdit();      // Units Per SKU has changed
      else if (oldWgt !== newWgt)
         handleStdNetWeightEdit(); // Std. Net Wt. has changed
      else
         handleBomHeaderSave(editBomCopy); // No base unit changes
   }

   function handleNewBomComponentEdit(opt) {
      const update = { ...newComponent, item: opt, quantity: 1, siteId: null };
      if (newComponent.itemGroup === constants.BOM_GROUP.Packaging && !_.isNil(opt)) {
         update.pkgType = opt.pkgType;
         if (opt.pkgType === constants.PKG_TYPE.CONE_TUBE_SPOOL) {
            update.quantity = itemClass.isEach
               ? 1
               : _.round(bom.unitsPerSku / bom.standardNetWeight, 5);
            if (update.quantity <= 0) {
               update.quantity = 1;
            }
         }
      } else if (newComponent.itemGroup === constants.BOM_GROUP.Chemical && !_.isNil(opt)) {
         let currQty = bom.finishNom / 100;
         if (currQty === 0) {
            toast.warning("Parent item has no nominal finish. Enter manual Quantity.");
         }

         if (!itemClass.isEach) {
            let yarnQty = 0;
            let chemQty = 0;

            for (let i = 0; i < bom.componentCollection.length; i++) {
               if (bom.componentCollection[i].itemGroup === 3) {
                  yarnQty += bom.componentCollection[i].quantity;
               } else if (bom.componentCollection[i].itemGroup === 1) {
                  chemQty += bom.componentCollection[i].quantity;
               }
            }
            let maxQty = 1 - yarnQty - chemQty;

            if (currQty > maxQty) {
               if (maxQty > 0) {
                  // This is all the qty allowed for additional chemical items right now
                  currQty = maxQty;
               } else {
                  // total quantity has exceeded 1
                  toast.error("Total Yarn + Chemical Quantity is maxed out.");
                  update.item = null;
               }
            }
         }
         update.quantity = currQty;
      } else if (newComponent.itemGroup === constants.BOM_GROUP.Yarn && !_.isNil(opt)) {
         if (!itemClass.isEach) {
            let yarnQty = 0;
            let chemQty = 0;
            let finish = bom.finishNom / 100;
            let compCount = bom.componentCollection?.length || 0;
            for (let i = 0; i < compCount; i++) {
               if (bom.componentCollection[i].itemGroup === 3) {
                  yarnQty += bom.componentCollection[i].quantity;
               } else if (bom.componentCollection[i].itemGroup === 1) {
                  chemQty += bom.componentCollection[i].quantity;
               }
            }

            let maxQty = 1 - finish - yarnQty - chemQty;
            if (maxQty <= 0) {
               toast.warning("Total Yarn (or Yarn + Chemical) Quantity is maxed out.");
               return;
            }

            update.quantity = maxQty;
         }
      }
      setNewComponent(update);
   }

   function handleNewPkgComponentQty() {
      // PkgType = Box/Divider when this is called
      if (newComponentPkgQty.trim() === "" ||
         newComponentPkgQty === null ||
         !Number.isInteger(Number(newComponentPkgQty))
      ) {
         toast.error("Packaging Item: Qty Per SKU must be entered and a whole number.");
         return;
      }

      setCalculatingPkgQty(true);
      let itemQty;
      if (itemClass.isEach) {
         itemQty = parseInt(newComponentPkgQty) / parseInt(bom.unitsPerSku);
      } else {
         itemQty = parseInt(newComponentPkgQty) / parseInt(bom.standardNetWeight);
      }

      setNewComponent({
         ...newComponent,
         pkgType: 2,
         unitsPerSku: newComponentPkgQty,
         quantity: itemQty,
      });

      setCalculatingPkgQty(false);
   }

   function handleStdNetWeightEdit() {
      if (_.isNil(editBomCopy)) return;
      const bCopy = _.assign({}, editBomCopy);
      const oldStdWgt = parseFloat(bom.standardNetWeight || 0);
      const isEachType = itemClass.isEach; // constants.Is_Each.includes(bCopy.itemClass);

      console.log(bCopy.componentCollection);
      _.forEach(bCopy.componentCollection, (c) => {
         switch (c.itemGroup) {
            case constants.BOM_GROUP.Yarn:
               if (isEachType) {
                  if (c.unitsPerSku <= 0) {
                     c.unitsPerSku = bCopy.unitsPerSku * c.quantity;
                  }
               } else {
                  c.unitsPerSku = bCopy.standardNetWeight * c.quantity;
               }
               break;

            case constants.BOM_GROUP.Packaging:
               if (isEachType) {
                  if (c.unitsPerSku <= 0) {
                     c.unitsPerSku = c.quantity * bCopy.unitsPerSku;
                  }
               } else {
                  if (c.unitsPerSku <= 0) {
                     c.unitsPerSku = c.quantity * oldStdWgt;
                  }
                  c.quantity = c.unitsPerSku / bCopy.standardNetWeight;
                  let wf = c.wasteFactor || 0;
                  c.extendedCost = c.currentCost * (c.quantity + wf);
               }
               break;

            case constants.BOM_GROUP.Chemical:
               if (isEachType) {
                  if (c.unitsPerSku <= 0) {
                     c.unitsPerSku = bCopy.unitsPerSku * c.quantity;
                  }
               } else {
                  c.unitsPerSku = bCopy.standardNetWeight * c.quantity;
               }
               break;

            default:
               toast(`Unable to determine the component type of ${c.itemNumber}!`);
               return;
         }
         updateCost(bCopy);
         setEditBomCopy(bCopy);
      });
      handleBomHeaderSave(bCopy);
   }

   function handleTareCheckEdit(key, value, index) {
      if (_.isNil(editBomCopy)) return;
      const bomCopy = _.assign({}, editBomCopy);
      bomCopy.pkgCollection[index][key] = value;
      setEditBomCopy(bomCopy);
   }

   function handleTareWeightEdit() {
      if (_.isNil(editBomCopy)) return;
      updateCost(editBomCopy);
      handleBomHeaderSave(editBomCopy);
   }

   function handleTariffEdit(key, value) {
      if (_.isNil(editTariffCopy)) return;
      const tariffCopy = _.assign({}, editTariffCopy);
      tariffCopy[key] = value;
      setEditTariffCopy(tariffCopy);
   }

   function handleTariffSave() {
      setWorking(true);
      const payload = editTariffCopy;
      payload.itemNumber = selectedItem.value;
      api
         .post("BOM/SaveTariffInfo", payload)
         .then((r) => {
            if (r.data.success) {
               setEditTariffCopy(null);
               refreshData();
            } else {
               toast.error(r.data.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setWorking(false));
   }

   function handleTypeahead(opt) {
      setEditBomCopy(null);
      setEditTariffCopy(null);
      if (_.isNil(opt)) {
         navigate(constants.ENDPOINTS.bomComponents, { state: null, replace: true, });
         setBom({});
         setItemClass({});
         setTariffInfo({});
         setWhereUsedItem(null);
      } else {
         navigate(constants.ENDPOINTS.bomComponents, { state: opt, replace: true, });
      }
   }

   function handleUpdateCost() {
      updateCost(editBomCopy);
      handleBomHeaderSave(editBomCopy);
   }

   function onSaveComponent(index) {
      if (_.isNil(editBomCopy)) return;
      const bomCopy = _.assign({}, editBomCopy);
      let component = _.assign({}, bomCopy.componentCollection[index]);
      let itemQty = parseFloat(component.quantity);
      let units = parseFloat(component.unitsPerSku);
      const waste = parseFloat(component.wastePercent);
      const bomCopyStdWeight = parseFloat(bomCopy.standardNetWeight);
      const isEachType = itemClass.isEach; // constants.Is_Each.includes(bomCopy.itemClass.trim());

      if (component.itemGroup !== constants.BOM_GROUP.Packaging && !isEachType) {
         let yarnQty = 0;
         let chemQty = 0;

         for (let i = 0; i < bomCopy.componentCollection.length; i++) {
            if (bomCopy.componentCollection[i].itemGroup === 3) {
               yarnQty += bomCopy.componentCollection[i].quantity;
            } else if (bomCopy.componentCollection[i].itemGroup === 1) {
               chemQty += bomCopy.componentCollection[i].quantity;
            }
         }

         if (yarnQty + chemQty > 1) {
            toast.error("Total (Yarn + Chemical) Qty cannot exceed 1.");
            return;
         }
      }

      if (component.itemGroup === constants.BOM_GROUP.Packaging) {
         // User cannot edit usage qty entry field, force it to be based on the units per sku as per current entry value
         // SHOULD THIS BE BASED ON PKG TYPE (Box/Divder vs. Cone/Tube/Spool) ??

         if (isEachType) {
            component.quantity = units / bomCopy.unitsPerSku;
         } else {
            component.quantity = units / bomCopyStdWeight;
         }
      } else {
         // User cannot edit units per sku entry field, force it to be based on the usage qty as per current entry value
         if (isEachType) {
            component.unitsPerSku = itemQty * bomCopy.unitsPerSku;
         } else {
            component.unitsPerSku = itemQty * bomCopyStdWeight;
         }
      }
      component.extendedCost = component.currentCost * (component.quantity + waste / 100.0);
      // component.quantity = _.toString(component.quantity);
      // component.unitsPerSku = _.toString(component.unitsPerSku);
      bomCopy.componentCollection[index] = component;
      updateCost(bomCopy);
      setEditBomCopy(bomCopy);
      handleBomHeaderSave(bomCopy);
   }

   function onUpdateBOMComponentValue(fieldName, value, index) {
      if (_.isNil(editBomCopy)) return;
      const bomCopy = _.assign({}, editBomCopy);
      let component = _.assign({}, bomCopy.componentCollection[index]);
      component[fieldName] = value;
      bomCopy.componentCollection[index] = component;
      setEditBomCopy(bomCopy);
   }

   function refreshData() {
      if (!selectedItem || !selectedItem.value) return;
      let isState = location?.state ? true : false;
      setShowNoBomMessage(false);
      setWorking(true);
      setBom({});
      setItemClass({});
      setTariffInfo({});
      setEditBomCopy(null);
      setWhereUsedItem(null);
      setNewComponentPkgQty("");
      api
         .fetch(`BOM/GetBom`, {
            itemNumber: selectedItem.value,
            canEdit: screenOptions.canEdit,
            isState: isState,
         })
         .then((r) => {
            if (r.data.success) {
               setBom(r.data.bom);
               setItemClass(_.isNil(r.data.itemClass) ? {} : r.data.itemClass);
               setTariffInfo(_.isNil(r.data.tariffInfo) ? {} : r.data.tariffInfo);
               setBomTotalCosts({
                  laborOverhead: _.round(
                     _.toNumber(r.data.bom.overheadAmount) +
                     _.toNumber(r.data.bom.laborAmount) +
                     _.toNumber(r.data.bom.otherCost),
                     2
                  ),
                  component: _.round(
                     _.sumBy(
                        r.data.bom.componentCollection,
                        (cmp) => cmp.extendedCost
                     ),
                     2
                  ),
               });
            } else {
               setShowNoBomMessage(true);
               toast.error(r.data.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setWorking(false));
   }

   function sendCompletedEmail() {
      setWorking(true);
      api
         .fetch(`BOM/CompleteBom/${bom.itemNumber}`)
         .then((r) => {
            if (r.data.success) {
               refreshData();
            } else {
               toast.error(r.data.message);
               setWorking(false);
            }
         })
         .catch((err) => {
            console.error(err);
            setWorking(false);
         });
   }

   function toggleEdit() {
      setEditBomCopy(editBomCopy === null ? _.cloneDeep(bom) : null);
      setNewComponentPkgQty(""); // clear it whether initiating editing or ending an edit
   }

   function updateCost(bomCopy) {
      const totalUnitCost = _.sum(
         bomCopy.componentCollection,
         (x) => x.extendedCost
      );
      setBomTotalCosts({
         ...bomTotalCosts,
         laborOverhead: helpers.formatCurrency(bomCopy.overheadAmount + bomCopy.laborAmount + bomCopy.otherCost),
         component: helpers.formatCurrency(totalUnitCost),
      });
   }

   return (
      <DesktopContainer screenName={"BoM Card"}>
         <div className="filter-header mb-3">
            <Row className="justify-content-center align-items-center">
               <Col xs={2} className="text-end pt-1">
                  <h5 children="Item Number" className="text-white" />
               </Col>
               <Col xs={6}>
                  <BOMTypeahead
                     value={selectedItem}
                     onChange={(opt) => handleTypeahead(opt)}
                     itemGroup={constants.BOM_GROUP.Undefined}
                     includeSamples={true}
                  />
               </Col>
               <Col xs={2}>
                  <Button className="shredButton" onClick={downloadBomPdf}>
                     SHOW REPORT
                  </Button>
               </Col>
            </Row>
         </div>

         {!selectedItem || !selectedItem.value ? (
            <div className="h5 text-center">Please select an item</div>
         ) : (
            <ServiceThreadSpinner on={working}>
               {showNoBomMessage ? (
                  <div className="fw-bold text-danger text-center">
                     No Bill Of Material found for item {selectedItem.value}
                  </div>
               ) : (
                  <>
                     <Card className="dashboard-card">
                        <CardBody>
                           <Row>
                              <Col xs="6">
                                 <a className="fw-bold me-3 shredHeader"
                                    href=""
                                    onClick={(event) => {
                                       reportHelpers.downloadSpecReportPdf(bom.itemNumber);
                                       event.preventDefault();
                                    }}
                                 >
                                    {bom.itemWithDesc}
                                 </a>
                                 <Button
                                    className={classNames("shredButton me-2", { "d-none": !screenOptions.canEdit, })}
                                    style={{ width: "9rem" }}
                                    title={editing ? "Cancel BOM Edit" : "Edit BOM"}
                                    children={editing ? "Cancel" : "Edit"}
                                    onClick={toggleEdit}
                                 />
                                 <Button
                                    className={classNames("shredButton", {
                                       "d-none": !editing || !currentUser.isAdmin || bom.bomId === 0,
                                    })}
                                    style={{ width: "9rem" }}
                                    title="Delete BOM"
                                    children="Delete"
                                    onClick={() => setConfirmDelete(true)}
                                 />
                              </Col>
                              <Col xs="3" className="pt-2">
                                 <Input
                                    type="checkbox"
                                    checked={screenOptions.showRevision}
                                    className="me-3"
                                    onChange={() =>
                                       setScreenOptions({
                                          ...screenOptions,
                                          showRevision: !screenOptions.showRevision,
                                       })
                                    }
                                 />
                                 Show Revision Notes?
                              </Col>
                              <Col xs="3" className={classNames({ "text-muted": _.isNil(editBomCopy) }, "pt-2")} >
                                 <Input
                                    type="checkbox"
                                    className="me-3"
                                    checked={getBomHeaderValue("allowOverrides")}
                                    onChange={(e) => handleBomHeaderEdit("allowOverrides", e.target.checked)}
                                    disabled={_.isNil(editBomCopy)}
                                 />{" "}
                                 Allow Global Updates?
                              </Col>
                           </Row>
                           <hr />
                           <Row className="justify-content-center my-3">
                              <Col xs="6">
                                 <Row className="align-items-center">
                                    <Col xs="4" className="fw-bold">
                                       Item Class:
                                    </Col>
                                    <Col>
                                       <Input className="readonly-input" value={bom.itemClass} readOnly />
                                    </Col>
                                 </Row>
                                 <Row className={classNames("align-items-center", { "d-none": !screenOptions.canEdit, })}>
                                    <Col xs="4" className="fw-bold">
                                       Overhead Acct:
                                    </Col>
                                    <Col>
                                       <Input
                                          className="readonly-input"
                                          value={
                                             bom &&
                                             bom.overheadGLAccount &&
                                             bom.overheadGLAccount.accountNumberWithDescription
                                          }
                                          readOnly
                                       />
                                    </Col>
                                 </Row>
                                 <Row className={classNames("align-items-center", { "d-none": !screenOptions.canEdit, })}>
                                    <Col xs="4" className="fw-bold">
                                       Labor Acct:
                                    </Col>
                                    <Col>
                                       <Input
                                          className="readonly-input"
                                          value={
                                             bom &&
                                             bom.laborGLAccount &&
                                             bom.laborGLAccount.accountNumberWithDescription
                                          }
                                          readOnly
                                       />
                                    </Col>
                                 </Row>
                                 <Row className={classNames("align-items-center", { "d-none": !screenOptions.canEdit, })}>
                                    <Col xs="4" className="fw-bold">
                                       Default Inv. Location:
                                    </Col>
                                    <Col xs="8">
                                       <Select
                                          classNamePrefix="serviceThreadSelect"
                                          styles={editing ? {} : constants.READONLY_SELECT_STYLE_WIDE}
                                          options={refData.sites}
                                          value={_.find(
                                             refData.sites,
                                             (x) => x.value === getBomHeaderValue("defaultSite")
                                          )}
                                          onChange={(opt) => handleBomHeaderEdit("defaultSite", opt.value)}
                                          isDisabled={!editing}
                                          isSearchable
                                       />
                                    </Col>
                                 </Row>
                                 <Row className="align-items-center mt-1">
                                    <Col xs="4" className="fw-bold">
                                       Standard Net Weight:
                                    </Col>
                                    <Col xs="6">
                                       <NumberFormat
                                          className={classNames(`form-control`, { "readonly-input": !editing, })}
                                          value={getBomHeaderValue("standardNetWeight", 0)}
                                          onValueChange={({ floatValue }) => {
                                             if (floatValue > 9999) floatValue = 9999;
                                             handleBomHeaderEdit("standardNetWeight", `${floatValue}`);
                                          }}
                                          allowNegative={false}
                                          readOnly={!editing}
                                       />
                                    </Col>
                                    <Col xs="1">
                                       <Button
                                          className={classNames("shredButton me-0", { "d-none": !editing, })}
                                          title="Save Std. Net Weight"
                                          children="Save"
                                          onClick={() => {
                                             setConfirmationModalOpen(true);
                                             setHandleConfirmConfirmationModal(() => handleStdNetWeightEdit);
                                          }}
                                       />
                                    </Col>
                                 </Row>
                                 <Row className="align-items-center mt-1">
                                    <Col xs="4" className="fw-bold">
                                       Tare Weight:
                                    </Col>
                                    <Col xs="6">
                                       <NumberFormat
                                          className={classNames(`form-control`, { "readonly-input": !editing, })}
                                          value={getBomHeaderValue("tareWeight", 0)}
                                          onValueChange={({ floatValue }) => {
                                             if (floatValue > 999) floatValue = 999;
                                             handleBomHeaderEdit("tareWeight", `${floatValue}`);
                                          }}
                                          allowNegative={false}
                                          readOnly={!editing}
                                       />
                                    </Col>
                                    <Col xs="1">
                                       <Button
                                          className={classNames("shredButton me-0", { "d-none": !editing, })}
                                          title="Save Tare Weight"
                                          children="Save"
                                          onClick={() => {
                                             setConfirmationModalOpen(true);
                                             setHandleConfirmConfirmationModal(() => handleTareWeightEdit);
                                          }}
                                       />
                                    </Col>
                                 </Row>
                                 <Row className="align-items-center mt-1">
                                    <Col xs="4" className="fw-bold">
                                       Units Per SKU:
                                    </Col>
                                    <Col xs="6">
                                       <NumberFormat
                                          className={classNames(`form-control`, { "readonly-input": !editing, })}
                                          value={getBomHeaderValue("unitsPerSku", 0)}
                                          onValueChange={({ floatValue }) => {
                                             if (floatValue > 9999) floatValue = 9999;
                                             handleBomHeaderEdit("unitsPerSku", `${floatValue}`);
                                          }}
                                          allowNegative={false}
                                          readOnly={!editing}
                                       />
                                    </Col>
                                    <Col xs="1">
                                       <Button
                                          className={classNames("shredButton me-2", { "d-none": !editing, })}
                                          title="Save Units Per Sku"
                                          children="Save"
                                          onClick={() => {
                                             setConfirmationModalOpen(true);
                                             setHandleConfirmConfirmationModal(() => handleBomUnitEdit);
                                          }}
                                       />
                                    </Col>
                                 </Row>
                                 <Row className="align-items-center mt-1">
                                    <Col xs="4" className="fw-bold">
                                       Min Order Qty:
                                    </Col>
                                    <Col xs="6">
                                       <NumberFormat
                                          className={classNames(`form-control`, { "readonly-input": !editing, })}
                                          value={getBomHeaderValue("realMinOrderQty", 0)}
                                          onValueChange={({ floatValue }) => {
                                             if (floatValue > 999999999)
                                                floatValue = 999999999;
                                             handleBomHeaderEdit("realMinOrderQty", `${floatValue}`);
                                          }}
                                          allowNegative={false}
                                          readOnly={!editing}
                                       />
                                    </Col>
                                    <Col xs="1">
                                       <Button
                                          className={classNames("shredButton me-0", { "d-none": !editing, })}
                                          title="Save Min Order Qty"
                                          children="Save"
                                          onClick={() => {
                                             setConfirmationModalOpen(true);
                                             setHandleConfirmConfirmationModal(() => handleMinOrderQtyEdit);
                                          }}
                                       />
                                    </Col>
                                 </Row>
                                 <Row className="align-items-center">
                                    <Col xs="4" className="fw-bold">
                                       Qty On Hand:
                                    </Col>
                                    <Col xs="8">
                                       <NumberFormat
                                          className={"form-control readonly-input"}
                                          value={getBomHeaderValue("qtyOnHand", 0)}
                                          readOnly={!editing}
                                       />
                                    </Col>
                                 </Row>
                              </Col>
                              <Col xs="6" className={classNames({ "d-none": !screenOptions.canEdit, })} >
                                 <Row className="align-items-center">
                                    <Col xs="4" className="fw-bold">
                                       Overhead Amount:
                                    </Col>
                                    <Col xs="8">
                                       <NumberFormat
                                          className={classNames(`form-control`, { "readonly-input": !editing, })}
                                          value={getBomHeaderValue("overheadAmount", 0)}
                                          onValueChange={({ floatValue }) => handleBomHeaderEdit("overheadAmount", floatValue)}
                                          prefix="$"
                                          decimalScale={2}
                                          fixedDecimalScale
                                          allowNegative={false}
                                          readOnly={!editing}
                                       />
                                    </Col>
                                 </Row>
                                 <Row className="align-items-center">
                                    <Col xs="4" className="fw-bold">
                                       Labor Amount:
                                    </Col>
                                    <Col xs="8">
                                       <NumberFormat
                                          className={classNames(`form-control`, { "readonly-input": !editing, })}
                                          value={getBomHeaderValue("laborAmount", 0)}
                                          onValueChange={({ floatValue }) => handleBomHeaderEdit("laborAmount", floatValue)}
                                          prefix="$"
                                          decimalScale={2}
                                          fixedDecimalScale
                                          allowNegative={false}
                                          readOnly={!editing}
                                       />
                                    </Col>
                                 </Row>
                                 <Row className="align-items-center">
                                    <Col xs="4" className="fw-bold">
                                       Other Cost:
                                    </Col>
                                    <Col xs="8">
                                       <NumberFormat
                                          className={classNames(`form-control`, { "readonly-input": !editing, })}
                                          value={getBomHeaderValue("otherCost", 0)}
                                          onValueChange={({ floatValue }) => handleBomHeaderEdit("otherCost", floatValue)}
                                          prefix="$"
                                          decimalScale={2}
                                          fixedDecimalScale
                                          allowNegative={false}
                                          readOnly={!editing}
                                       />
                                    </Col>
                                 </Row>
                                 <Row className="align-items-center">
                                    <Col xs="4" className="fw-bold">
                                       Total Labor &amp; Overhead:
                                    </Col>
                                    <Col xs="8">
                                       <NumberFormat
                                          className="form-control readonly-input"
                                          value={bomTotalCosts.laborOverhead}
                                          prefix="$"
                                          decimalScale={2}
                                          fixedDecimalScale
                                          readOnly={!editing}
                                       />
                                    </Col>
                                 </Row>
                                 <Row className="align-items-center">
                                    <Col xs="4" className="fw-bold">
                                       Total Component Cost:
                                    </Col>
                                    <Col xs="8">
                                       <NumberFormat
                                          className="form-control readonly-input"
                                          value={bomTotalCosts.component}
                                          prefix="$"
                                          decimalScale={2}
                                          fixedDecimalScale
                                          readOnly={!editing}
                                       />
                                    </Col>
                                 </Row>
                                 <Row className="align-items-center">
                                    <Col xs="4" className="fw-bold">
                                       Total Unit Cost:
                                    </Col>
                                    <Col xs="8">
                                       <NumberFormat
                                          className="form-control readonly-input"
                                          value={bomTotalCosts.laborOverhead + bomTotalCosts.component}
                                          prefix="$"
                                          decimalScale={2}
                                          fixedDecimalScale
                                          readOnly={!editing}
                                       />
                                    </Col>
                                 </Row>
                                 {editing && (
                                    <Row className="align-items-center">
                                       <Col xs="4" />
                                       <Col xs="8">
                                          <Button
                                             className={"shredButton"}
                                             onClick={() => {
                                                setConfirmationModalOpen(true);
                                                setHandleConfirmConfirmationModal(() => handleUpdateCost);
                                             }}
                                          >
                                             Update Cost
                                          </Button>
                                       </Col>
                                    </Row>
                                 )}
                                 <Row className="mt-5">
                                    <Col xs="4" />
                                    <Col>
                                       <Button
                                          className={classNames("shredButton", { "d-none": !editing, })}
                                          onClick={sendCompletedEmail}
                                       >
                                          Send Completed Email
                                       </Button>
                                    </Col>
                                 </Row>
                              </Col>
                           </Row>
                        </CardBody>
                     </Card>
                     {headerIncomplete ? (
                        <>
                           {(_.isNil(bom.standardNetWeight) || _.trim(bom.standardNetWeight).length === 0) && (
                              <div
                                 className="fw-bold text-danger"
                                 children={"Standard Net Weight must be updated to continue"}
                              />
                           )}
                           {itemClass.isFinishedGood &&
                              (_.isNil(bom.tareWeight) || _.trim(bom.tareWeight).length === 0) && (
                                 <div
                                    className="fw-bold text-danger"
                                    children={"Tare Weight must be updated to continue"}
                                 />
                              )}
                           {(_.isNil(bom.unitsPerSku) || _.trim(bom.unitsPerSku).length === 0) && (
                              <div
                                 className="fw-bold text-danger"
                                 children={"Units Per Sku must be updated to continue"}
                              />
                           )}
                        </>
                     ) : (
                        <>
                           <Card className="dashboard-card">
                              <CardBody>
                                 <Row className="mb-2">
                                    <Col>
                                       <span className="h2 me-2">BOM Components</span>
                                    </Col>
                                    <Col>
                                       {bom.componentCollection &&
                                          bom.componentCollection.length !== 0 && (
                                             <Button
                                                title="Download as .xlsx"
                                                className="shredButtonExcel float-end"
                                                onClick={() => downloadComponentXLSX()}
                                             >
                                                <FontAwesomeIcon icon="file-excel" size="lg" />
                                             </Button>
                                          )}
                                    </Col>
                                 </Row>
                                 <hr />
                                 {bom.componentCollection && bom.componentCollection.length ? (
                                    <Table size="sm" className="data-table">
                                       <thead className="table-header">
                                          <tr>
                                             <th className="" width="18%">Component Item</th>
                                             <th className="ps-3" width="10%">Site</th>
                                             <th className="ps-3" width="5%">Units Per Sku</th>
                                             <th className="ps-3" width="7%">Usage Qty</th>
                                             <th className="ps-3" width="5%">Waste %</th>
                                             <th className="" width="4%">Vendor</th>
                                             <th
                                                className={classNames("ps-3", { "d-none": !screenOptions.canEdit, })}
                                                width="6%"
                                             >
                                                Current Cost
                                             </th>
                                             <th
                                                className={classNames("ps-3", { "d-none": !screenOptions.canEdit, })}
                                                width="6%"
                                             >
                                                Ext. Cost
                                             </th>
                                             <th className="ps-3" width="6%">PLT</th>
                                             <th className="ps-3" width="6%">PLTWHSE</th>
                                             <th className="ps-3" width="6%">OTHER SITES</th>
                                             <th className="" width="3%">QC Hold</th>
                                             <th className="" width="3%"></th>
                                             {/*<th*/}
                                             {/*   className={classNames({"d-none": !screenOptions.canEdit,})}*/}
                                             {/*   width="3%"*/}
                                             {/*></th>*/}
                                             {editing ? (
                                                <th className={classNames({ "d-none": !screenOptions.canEdit, })} width="8%"></th>
                                             ) : null}
                                          </tr>
                                       </thead>
                                       <tbody>
                                          {_.map(bom.componentCollection, (cmp, index) => (
                                             <tr
                                                key={index}
                                                className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
                                             >
                                                <ItemDropdownMenu
                                                   itemNumber={cmp.itemNumber}
                                                   itemDescription={cmp.itemWithDesc}
                                                   attachmentCount={cmp.itemAttachmentCount}
                                                   bomReplace
                                                />
                                                <td>
                                                   <Select
                                                      classNamePrefix="serviceThreadSelect"
                                                      styles={editing ? {} : constants.READONLY_SELECT_STYLE}
                                                      options={refData.sites}
                                                      value={_.find(
                                                         refData.sites,
                                                         (x) => x.value === getBomComponentValue("siteId", index)
                                                      )}
                                                      onChange={(opt) => onUpdateBOMComponentValue("siteId", opt.value, index)}
                                                      isDisabled={!editing}
                                                      isSearchable
                                                   />
                                                </td>
                                                <td>
                                                   <NumberFormat
                                                      className={classNames("form-control", {
                                                         "readonly-input":
                                                            !editing || _.includes(
                                                               [
                                                                  constants.BOM_GROUP.Chemical,
                                                                  constants.BOM_GROUP.Yarn,
                                                               ],
                                                               cmp.itemGroup
                                                            ),
                                                      })}
                                                      value={getBomComponentValue("unitsPerSku", index, 0)}
                                                      onValueChange={({ floatValue }) => {
                                                         if (floatValue === 0 &&
                                                            cmp.itemGroup === constants.BOM_GROUP.Packaging
                                                         )
                                                            floatValue = 1;
                                                         onUpdateBOMComponentValue("unitsPerSku", floatValue, index);
                                                      }}
                                                      decimalScale={
                                                         cmp.itemGroup === constants.BOM_GROUP.Packaging
                                                            ? 0
                                                            : 5
                                                      }
                                                      allowNegative={false}
                                                      readOnly={
                                                         !editing || _.includes(
                                                            [
                                                               constants.BOM_GROUP.Chemical,
                                                               constants.BOM_GROUP.Yarn,
                                                            ],
                                                            cmp.itemGroup
                                                         )
                                                      }
                                                   />
                                                </td>
                                                <td>
                                                   <NumberFormat
                                                      className={classNames("form-control", {
                                                         "readonly-input":
                                                            !editing ||
                                                            cmp.itemGroup === constants.BOM_GROUP.Packaging,
                                                      })}
                                                      value={getBomComponentValue("quantity", index, 0)}
                                                      onValueChange={({ floatValue }) => {
                                                         if (floatValue > 1 &&
                                                            _.includes(
                                                               [
                                                                  constants.BOM_GROUP.Chemical,
                                                                  constants.BOM_GROUP.Yarn,
                                                               ],
                                                               cmp.itemGroup
                                                            )
                                                         ) // eslint-disable-next-line no-self-assign
                                                            floatValue = floatValue;

                                                         onUpdateBOMComponentValue("quantity", floatValue, index);
                                                      }}
                                                      decimalScale={5}
                                                      allowNegative={false}
                                                      readOnly={
                                                         !editing ||
                                                         cmp.itemGroup === constants.BOM_GROUP.Packaging
                                                      }
                                                   />
                                                </td>
                                                <td>
                                                   <NumberFormat
                                                      className={classNames("form-control", { "readonly-input": !editing, })}
                                                      value={getBomComponentValue("wastePercent", index, 0).toFixed(2)}
                                                      onValueChange={({ floatValue }) => {
                                                         if (floatValue > 100) floatValue = 100;
                                                         onUpdateBOMComponentValue("wastePercent", floatValue, index);
                                                      }}
                                                      decimalScale={4}
                                                      allowNegative={false}
                                                      readOnly={!editing}
                                                   />
                                                </td>
                                                <td>{cmp.vendorId}</td>
                                                <td className={classNames({ "d-none": !screenOptions.canEdit, })} >
                                                   <NumberFormat
                                                      className="form-control readonly-input"
                                                      value={cmp.currentCost}
                                                      prefix="$"
                                                      decimalScale={4}
                                                      readOnly
                                                   />
                                                </td>
                                                <td className={classNames({ "d-none": !screenOptions.canEdit, })} >
                                                   <NumberFormat
                                                      className="form-control readonly-input"
                                                      value={cmp.extendedCost}
                                                      prefix="$"
                                                      decimalScale={4}
                                                      readOnly
                                                   />
                                                </td>
                                                <td>
                                                   <NumberFormat
                                                      className="form-control readonly-input"
                                                      value={cmp.quantityPlant}
                                                      decimalScale={0}
                                                      thousandSeparator=","
                                                      readOnly
                                                   />
                                                </td>
                                                <td>
                                                   <NumberFormat
                                                      className="form-control readonly-input"
                                                      value={cmp.quantityWarehouse}
                                                      decimalScale={0}
                                                      thousandSeparator=","
                                                      readOnly
                                                   />
                                                </td>
                                                <td>
                                                   <NumberFormat
                                                      className="form-control readonly-input"
                                                      value={cmp.quantityOtherSites}
                                                      decimalScale={0}
                                                      thousandSeparator=","
                                                      readOnly
                                                   />
                                                </td>
                                                <td className="text-red fst-italic text-center align-middle">
                                                   {cmp.qcHold && "HOLD"}
                                                </td>
                                                <td className="text-center">
                                                   <span
                                                      className="boldedOrange cursor-pointer"
                                                      onClick={() => {
                                                         setWuPage({ ...wuPage, number: 1 });
                                                         setWhereUsedItem(cmp.itemNumber);
                                                      }}
                                                   >
                                                      Where Used
                                                   </span>
                                                </td>
                                                {/*<td className={classNames("text-center", {"d-none": !screenOptions.canEdit,})} >*/}
                                                {/*   {cmp.hasSubBom && (*/}
                                                {/*      <span*/}
                                                {/*         className="boldedOrange cursor-pointer"*/}
                                                {/*         onClick={() =>*/}
                                                {/*            navigate(constants.ENDPOINTS.bomComponents,*/}
                                                {/*               {*/}
                                                {/*                  state: {*/}
                                                {/*                     label: cmp.itemWithDesc,*/}
                                                {/*                     value: cmp.itemNumber,*/}
                                                {/*                  },*/}
                                                {/*                  replace: true,*/}
                                                {/*               }*/}
                                                {/*            )*/}
                                                {/*         }*/}
                                                {/*      >*/}
                                                {/*         Goto BOM*/}
                                                {/*      </span>*/}
                                                {/*   )}*/}
                                                {/*</td>*/}
                                                {editing ? (
                                                   <td className={classNames({ "d-none": !screenOptions.canEdit, })} >
                                                      {" "}
                                                      <Button
                                                         className={classNames("shredButton me-2", { "d-none": !editing, })}
                                                         title="Save Component Info"
                                                         onClick={() => onSaveComponent(index)}
                                                      >
                                                         <FontAwesomeIcon className="whiteIcon" icon="check" />
                                                      </Button>
                                                      <Button
                                                         className={classNames("icon-button", { invisible: !editing, })}
                                                         color="danger"
                                                         onClick={() => { setConfirmComponentDelete(cmp.componentId); }}
                                                         title="Delete BOM Component"
                                                         disabled={working}
                                                      >
                                                         <FontAwesomeIcon className="whiteIcon" icon="trash" />
                                                      </Button>
                                                   </td>
                                                ) : null}
                                             </tr>
                                          ))}
                                       </tbody>
                                       <tfoot className="table-footer">
                                          <tr>
                                             <td colSpan="14" />
                                          </tr>
                                       </tfoot>
                                    </Table>
                                 ) : (
                                    <Row>
                                       <span className="h5">No BOM Component Info Found</span>
                                    </Row>
                                 )}
                              </CardBody>
                           </Card>

                           <Card className="dashboard-card">
                              <CardBody>
                                 <Row className="mb-2">
                                    <Col>
                                       <span className="h2 me-2">Tare Check</span>
                                    </Col>
                                 </Row>
                                 <hr />
                                 {bom.pkgCollection && bom.pkgCollection.length ? (
                                    <Table size="sm" className="data-table">
                                       <thead className="table-header">
                                          <tr>
                                             <th>Component Item</th>
                                             <th className="ps-3 text-center">Qty Per SKU</th>
                                             <th className="ps-3 text-center">Usage Qty</th>
                                             <th className="ps-3 text-center">Weight</th>
                                             <th className="ps-3 text-center">Ext</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          {_.map(bom.pkgCollection, (t, index) => (
                                             <tr key={index}
                                                className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
                                             >
                                                <ItemDropdownMenu
                                                   itemNumber={t.itemNumber}
                                                   itemDescription={t.itemWithDesc}
                                                   attachmentCount={t.itemAttachmentCount}
                                                   bomReplace
                                                />
                                                <td>
                                                   <NumberFormat
                                                      className="tare-grid-text form-control readonly-input text-center d-l-white-black"
                                                      value={t.unitsPerSku}
                                                      decimalScale={4}
                                                      allowNegative={false}
                                                      readOnly
                                                      displayType="text"
                                                   />
                                                </td>
                                                <td>
                                                   <NumberFormat
                                                      className="form-control readonly-input text-center d-l-white-black"
                                                      value={t.quantity}
                                                      decimalScale={5}
                                                      readOnly
                                                      displayType="text"
                                                   />
                                                </td>
                                                <td>
                                                   <NumberFormat
                                                      style={{ color: "red" }}
                                                      className={classNames(
                                                         "text-center",
                                                         "form-control",
                                                         {
                                                            "d-l-white-black": !editing, // allow color text in edit mode
                                                            "readonly-input": !editing, // turn off readonly in edit mode
                                                         }
                                                      )}
                                                      value={getTareCheckValue("tareWeight", index, 0)}
                                                      onValueChange={({ floatValue }) => {
                                                         handleTareCheckEdit("tareWeight", floatValue, index);
                                                      }}
                                                      decimalScale={5}
                                                      allowNegative={false}
                                                      readOnly={!editing}
                                                   //displayType="text"
                                                   />
                                                </td>
                                                <td>
                                                   <NumberFormat
                                                      className="form-control readonly-input text-center d-l-white-black"
                                                      value={t.extendedWeight}
                                                      decimalScale={5}
                                                      readOnly
                                                      displayType="text"
                                                   />
                                                </td>
                                             </tr>
                                          ))}
                                       </tbody>
                                       <tfoot className="table-footer">
                                          <tr>
                                             <td colSpan={4} />
                                             <td className="fw-bold ps-3 text-center pe-3">
                                                {_.floor(_.sumBy(bom.pkgCollection, (pkg) => pkg.extendedWeight))}
                                             </td>
                                          </tr>
                                       </tfoot>
                                    </Table>
                                 ) : (
                                    <Row>
                                       <span className="h5">No Tare Check Info Found</span>
                                    </Row>
                                 )}
                              </CardBody>
                           </Card>

                           <Card className={classNames("dashboard-card")}>
                              <CardBody>
                                 <Row className="mb-2">
                                    <Col>
                                       <span className="h2">Tariff Information</span>
                                    </Col>
                                    <Col>
                                       <Button
                                          className={classNames("shredButton float-end ms-2", { "d-none": !editBomCopy, })}
                                          title="EditTariff Info "
                                          onClick={() => setEditTariffCopy(_.cloneDeep(tariffInfo))}
                                       >
                                          Edit Tariff Info
                                       </Button>
                                    </Col>
                                 </Row>
                                 <hr />
                                 {tariffInfo.tariffNumber ? (
                                    <>
                                       <Row>
                                          <Col xs="2">
                                             <span className="fw-bold">Tariff Number:</span>
                                          </Col>
                                          <Col xs="10">
                                             <span className="fw-bold">
                                                {tariffInfo.tariffNumber}
                                             </span>{" "}
                                             - {tariffInfo.description}
                                          </Col>
                                       </Row>
                                       <Row>
                                          <Col xs="2">
                                             <span className="fw-bold">
                                                Country of Origin:
                                             </span>
                                          </Col>
                                          <Col xs="10">{tariffInfo.countryOfOrigin}</Col>
                                       </Row>
                                       <Row>
                                          <Col xs="2">
                                             <span className="fw-bold">Origin Criteria:</span>
                                          </Col>
                                          <Col xs="10">{tariffInfo.originCriterion}</Col>
                                       </Row>
                                    </>
                                 ) : (
                                    <div className="h5 text-center">
                                       No Tariff Info Found
                                    </div>
                                 )}
                              </CardBody>
                           </Card>

                           {componentsIncomplete ? (
                              <div className={classNames("fw-bold text-danger", { "d-none": !editing, })} >
                                 Site, Qty Per Sku, Usage Qty, & Waste % must be provided
                                 for all components before any additional changes can be
                                 made.
                                 <br />
                                 Please remove any components with missing values and add
                                 them back again.
                              </div>
                           ) : (
                              <Card className={classNames("dashboard-card", { "d-none": !editing, })} >
                                 <CardBody>
                                    <Row className="mb-2">
                                       <Col>
                                          <span className="h2">Add New BOM Component</span>
                                          <Button
                                             className="shredButton float-end"
                                             onClick={handleBomComponentCreate}
                                             disabled={
                                                !newComponent.item ||
                                                !newComponent.siteId ||
                                                !newComponent.quantity
                                             }
                                          >
                                             Add Component
                                          </Button>
                                       </Col>
                                    </Row>
                                    <hr />
                                    <Row className="alignitems-left">
                                       <Col xs={3} className="d-flex align-items-center">
                                          <span className="fw-bold me-1">Type:</span>
                                          <Select
                                             className="flex-fill"
                                             options={refData.componentTypes}
                                             value={_.find(
                                                refData.componentTypes,
                                                (ct) => ct.value === newComponent.itemGroup
                                             )}
                                             onChange={(opt) =>
                                                setNewComponent({
                                                   itemGroup: opt.value,
                                                   item: null,
                                                   quantity: 1,
                                                   site: null,
                                                })
                                             }
                                             menuPlacement="auto"
                                          />
                                       </Col>
                                       <Col xs={3} className="d-flex align-items-center">
                                          <span className="fw-bold me-1">Item:</span>
                                          <BOMTypeahead
                                             className="flex-fill"
                                             onChange={handleNewBomComponentEdit}
                                             value={newComponent.item}
                                             itemGroup={newComponent.itemGroup}
                                             includeSamples={isSampleBom}
                                             menuPlacement="auto"
                                          />
                                       </Col>
                                       <Col xs={3} className="d-flex align-items-center">
                                          <span className="fw-bold me-1">Location:</span>
                                          <Select
                                             classNamePrefix="serviceThreadSelect"
                                             className="flex-fill"
                                             options={refData.sites}
                                             value={_.find(
                                                refData.sites,
                                                (x) => x.value === newComponent.siteId
                                             ) || null
                                             }
                                             onChange={(opt) =>
                                                setNewComponent({
                                                   ...newComponent,
                                                   siteId: opt.value,
                                                })
                                             }
                                             menuPlacement="auto"
                                             isSearchable
                                          />
                                       </Col>
                                       <Col xs={3} className="d-flex align-items-center">
                                          <ServiceThreadSpinner on={calculatingPkgQty}>
                                             <span className="fw-bold me-1">Quantity:</span>
                                             <NumberFormat
                                                className={classNames("form-control", {
                                                   "readonly-input":
                                                      newComponent.itemGroup === constants.BOM_GROUP.Packaging &&
                                                      newComponent.item,
                                                   //&& newComponent.item.pkgType !== constants.PKG_TYPE.BOX_DIVIDER,
                                                })}
                                                value={newComponent.quantity}
                                                onValueChange={({ floatValue }) =>
                                                   setNewComponent({
                                                      ...newComponent,
                                                      quantity: floatValue,
                                                   })
                                                }
                                                // decimalScale={
                                                //   newComponent.itemGroup === constants.BOM_GROUP.Packaging &&
                                                //   newComponent.item &&
                                                //   newComponent.item.pkgType === constants.PKG_TYPE.BOX_DIVIDER
                                                //     ? 0
                                                //     : 5
                                                // }
                                                readOnly={
                                                   newComponent.itemGroup === constants.BOM_GROUP.Packaging &&
                                                   newComponent.item &&
                                                   newComponent.item.pkgType !== constants.PKG_TYPE.BOX_DIVIDER
                                                }
                                             />
                                          </ServiceThreadSpinner>
                                       </Col>
                                    </Row>
                                    <Row // packaging and box divider types
                                       className={classNames({
                                          "d-none": !(
                                             newComponent.itemGroup === constants.BOM_GROUP.Packaging &&
                                             newComponent.item &&
                                             newComponent.item.pkgType === constants.PKG_TYPE.BOX_DIVIDER
                                          ),
                                       })}
                                    >
                                       <Col xs="3" className="text-center my-2">
                                          <span className="fst-italic">
                                             {itemClass.isEach
                                                ? "Qty Per SKU: (based on Units Per SKU)"
                                                : "Qty Per SKU: (based on Standard Net Wt)"}
                                          </span>
                                       </Col>
                                    </Row>
                                    <Row
                                       className={classNames({
                                          "d-none": !(
                                             newComponent.itemGroup === constants.BOM_GROUP.Packaging &&
                                             newComponent.item &&
                                             newComponent.item.pkgType === constants.PKG_TYPE.BOX_DIVIDER
                                          ),
                                       })}
                                    >
                                       <Col xs="3" className="d-flex align-items-center">
                                          <span className="fw-bold me-1">Qty:</span>
                                          <Input
                                             className="form-control ms-2"
                                             value={newComponentPkgQty}
                                             onChange={(e) => setNewComponentPkgQty(e.target.value)}
                                          />
                                       </Col>
                                       <Col xs="3" className="d-flex align-items-center">
                                          <Button className="shredButton" onClick={() => handleNewPkgComponentQty()} >
                                             CONTINUE
                                          </Button>
                                       </Col>
                                    </Row>
                                    <Row
                                       className={classNames(
                                          {
                                             "d-none":
                                                newComponent.itemGroup !== constants.BOM_GROUP.Packaging ||
                                                !newComponent.item ||
                                                _.includes(
                                                   [
                                                      constants.PKG_TYPE.CONE_TUBE_SPOOL,
                                                      constants.PKG_TYPE.BOX_DIVIDER,
                                                   ],
                                                   newComponent.item.pkgType
                                                ),
                                          },
                                          "mt-2"
                                       )}
                                    >
                                       <Col xs={3}>
                                          <span className="fw-bold me-1">
                                             Choose Packaging Type:
                                          </span>
                                          <Select
                                             classNamePrefix="serviceThreadSelect"
                                             className="flex-fill"
                                             options={refData.packageTypes}
                                             value={_.find(
                                                refData.packageTypes,
                                                (pt) => pt.value === newComponent.itemPkgType
                                             )}
                                             onChange={(opt) =>
                                                setNewComponent({
                                                   ...newComponent,
                                                   itemPkgType: opt.value,
                                                })
                                             }
                                          />
                                       </Col>
                                       <Col xs={3}>
                                          <span className="fw-bold me-1">
                                             Packaging Tare Weight:
                                          </span>
                                          <NumberFormat
                                             className="form-control"
                                             value={newComponent.itemTareWeight}
                                             onValueChange={({ floatValue }) => {
                                                if (floatValue < 0.0001) floatValue = 0.0001;
                                                if (floatValue > 99) floatValue = 99;
                                                setNewComponent({
                                                   ...newComponent,
                                                   itemTareWeight: floatValue,
                                                });
                                             }}
                                             decimalScale={4}
                                             allowNegative={false}
                                          />
                                       </Col>
                                    </Row>
                                 </CardBody>
                              </Card>
                           )}

                           <Card
                              id="whereUsedTable"
                              className={classNames("dashboard-card", { "d-none": whereUsedItem === null, })}
                           >
                              <CardBody>
                                 <Row className="mb-2">
                                    <Col>
                                       <span className="h2 me-2">Where Used</span>
                                       <FontAwesomeIcon
                                          icon="times"
                                          className="float-end cursor-pointer"
                                          onClick={() => setWhereUsedItem(null)}
                                       />
                                    </Col>
                                 </Row>
                                 <hr />
                                 <Row className="justify-content-center mt-4">
                                    <Col>
                                       <h4>Component Item: {whereUsedItem}</h4>
                                    </Col>
                                 </Row>
                                 <ServiceThreadSpinner on={wuWorking}>
                                    {whereUsedItemList && whereUsedItemList.length ? (
                                       <>
                                          <Table size="sm" className="data-table">
                                             <thead className="table-header">
                                                <tr>
                                                   <th>Item</th>
                                                   <th>Edit BOM</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                {_.map(whereUsedItemList, (c, index) => (
                                                   <tr key={index}>
                                                      <td>{c.itemWithDesc}</td>
                                                      <td
                                                         className="boldedOrange nav-link"
                                                         onClick={() => {
                                                            navigate(constants.ENDPOINTS.bomComponents,
                                                               {
                                                                  state: {
                                                                     label: c.itemWithDesc,
                                                                     value: c.itemNumber,
                                                                  },
                                                                  replace: true,
                                                               }
                                                            );
                                                            setWhereUsedItem(null);
                                                            window.scrollTo(0, 0);
                                                         }}
                                                      >
                                                         Show BOM
                                                      </td>
                                                   </tr>
                                                ))}
                                             </tbody>
                                             <tfoot>
                                                <tr>
                                                   <td colSpan="2" />
                                                </tr>
                                             </tfoot>
                                          </Table>
                                          <Pager
                                             callBack={(number) => setWuPage({ ...wuPage, number: number })}
                                             sizeCallback={(size) => setWuPage({ ...wuPage, size: size })}
                                             pageNumber={wuPage.number}
                                             pageSize={wuPage.size}
                                             totalPages={_.ceil(wuTotal / wuPage.size)}
                                             className={"float-start justify-content-center"}
                                          />
                                       </>
                                    ) : (
                                       <Row>
                                          <span className="h5">No Where Used Info Found</span>
                                       </Row>
                                    )}
                                 </ServiceThreadSpinner>
                              </CardBody>
                           </Card>

                           <Card className={classNames("dashboard-card", { "d-none": !screenOptions.showRevision, })} >
                              <CardBody>
                                 <Row className="mb-2">
                                    <Col>
                                       <span className="h2">Revision Notes</span>
                                    </Col>
                                 </Row>
                                 <hr />
                                 {bom.revisionNotes && bom.revisionNotes.length ? (
                                    <Table size="sm" className="data-table">
                                       <thead className="table-header">
                                          <tr>
                                             <th style={{ width: "50px" }}>Rev #</th>
                                             <th style={{ width: "90px" }}>Date</th>
                                             <th>Note</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          {_.map(bom.revisionNotes, (n, index) => (
                                             <tr key={index}
                                                className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
                                             >
                                                <td>{n.revNumber}</td>
                                                <td>{dateHelpers.toMDYDateString(n.revDate)}</td>
                                                <td>{n.fullNote}</td>
                                             </tr>
                                          ))}
                                       </tbody>
                                       <tfoot className="table-footer">
                                          <tr>
                                             <td colSpan="3" />
                                          </tr>
                                       </tfoot>
                                    </Table>
                                 ) : null}
                              </CardBody>
                           </Card>

                           <Modal size="lg" isOpen={editTariffCopy !== null}>
                              <ModalHeader toggle={() => setEditTariffCopy(null)}>
                                 Item Tariff Information
                              </ModalHeader>
                              <ModalBody>
                                 <Row>
                                    <Col>
                                       <Row className="mb-2">
                                          <Col xs="3" className="fw-bold">
                                             Item Number:
                                          </Col>
                                          <Col xs="9">
                                             <Input className="readonly-input" value={bom.itemNumber} readOnly />
                                          </Col>
                                       </Row>
                                       <Row className="mb-2">
                                          <Col xs="3" className="fw-bold">
                                             Tariff Number:
                                          </Col>
                                          <Col xs="9">
                                             <Select
                                                classNamePrefix="serviceThreadSelect"
                                                options={refData.tariffNumbers}
                                                value={_.find(
                                                   refData.tariffNumbers,
                                                   (x) => x.value === getTariffValue("tariffNumber")
                                                )}
                                                onChange={(opt) => { handleTariffEdit("tariffNumber", opt.value); }}
                                                isSearchable
                                             />
                                          </Col>
                                       </Row>
                                       <Row className="mb-2">
                                          <Col xs="3" className="fw-bold">
                                             Country of Origin:
                                          </Col>
                                          <Col xs="9">
                                             <Input
                                                value={getTariffValue("countryOfOrigin")}
                                                onChange={(e) => handleTariffEdit("countryOfOrigin", e.target.value)}
                                             />
                                          </Col>
                                       </Row>
                                       <Row className="mb-2">
                                          <Col xs="3" className="fw-bold">
                                             Origin Criteria:
                                          </Col>
                                          <Col xs="9">
                                             <Input
                                                type="radio"
                                                name="toc"
                                                className="me-1"
                                                checked={getTariffValue("originCriterion") === "A"}
                                                onChange={() => handleTariffEdit("originCriterion", "A")}
                                             />
                                             A
                                             <Input
                                                type="radio"
                                                name="toc"
                                                className="ms-4 me-1"
                                                checked={getTariffValue("originCriterion") === "B"}
                                                onChange={() => handleTariffEdit("originCriterion", "B")}
                                             />
                                             B
                                             <Input
                                                type="radio"
                                                name="toc"
                                                className="ms-4 me-1"
                                                checked={getTariffValue("originCriterion") === "C"}
                                                onChange={() => handleTariffEdit("originCriterion", "C")}
                                             />
                                             C
                                             <Input
                                                type="radio"
                                                name="toc"
                                                className="ms-4 me-1"
                                                checked={getTariffValue("originCriterion") === "D"}
                                                onChange={() => handleTariffEdit("originCriterion", "D")}
                                             />
                                             D
                                          </Col>
                                       </Row>
                                    </Col>
                                 </Row>
                              </ModalBody>
                              <ModalFooter className="float-right">
                                 <Button className="me-2" onClick={() => setEditTariffCopy(null)}>
                                    CANCEL
                                 </Button>
                                 <Button className="shredButton" onClick={handleTariffSave}>
                                    Send
                                 </Button>
                              </ModalFooter>
                           </Modal>
                        </>
                     )}

                     <ConfirmModal
                        confirmDelete={confirmationModalOpen}
                        approveConfirmDelete={() => {
                           handleConfirmConfirmationModal();
                           setConfirmationModalOpen(false);
                        }}
                        declineConfirmDelete={() => setConfirmationModalOpen(false)}
                        disabled={working}
                        warningMessage={
                           <>Are you sure you wish to update the BOM Header?</>
                        }
                        header="Confirm Update"
                     />

                     {/* CONFIRM DELETE BOM */}
                     <ConfirmModal
                        confirmDelete={confirmDelete}
                        approveConfirmDelete={handleBomHeaderDelete}
                        declineConfirmDelete={() => setConfirmDelete(null)}
                        disabled={working}
                        warningMessage={
                           <>
                              Are you sure you want to delete this BOM?
                              <br />
                              This will permanently remove it and all Components and
                              Tariff Info from the system.
                           </>
                        }
                     />

                     {/* CONFIRM DELETE COMPONENT */}
                     <ConfirmModal
                        confirmDelete={confirmComponentDelete}
                        approveConfirmDelete={handleBomComponentDelete}
                        declineConfirmDelete={() => setConfirmComponentDelete(null)}
                        disabled={working}
                        warningMessage={
                           <>
                              Are you sure you want to delete this BOM Component?
                              <br />
                              This will permanently remove it from the system.
                           </>
                        }
                     />
                  </>
               )}
            </ServiceThreadSpinner>
         )}
      </DesktopContainer>
   );
}
